import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { isValidAmount } from 'src/shared/validatorUtils';

export const dormitoryLunchFeeRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct dormitory lunch fee'),
    required: true,
    validator: async (_, value: string) => {
      if (Number(value) < 0) {
        throw new Error();
      }
      if (Number(value) > 50) {
        throw new Error();
      }
      if (!isValidAmount(Number(value))) {
        throw new Error();
      }
    },
  });
};
